import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const OfferRewardContainer = styled.div<{ isLoggedIn?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${p => (p.isLoggedIn ? 'gap: 0.5rem;' : 'gap: 1rem;')}
  background-color: white;
  padding: 1rem;
  ${p => !p.isLoggedIn && 'padding-block-end: 1.5rem;'}

  ${Styles.desktop} {
    padding-block-end: 1.5rem;
    ${p => (p.isLoggedIn ? 'padding-inline: 3rem;' : 'padding-inline: 20px;')}
  }

  ${Styles.desktopLarge} {
    gap: 0;
    padding-block-start: 1.25rem;
    padding-block-end: 2rem;
    padding-inline: 9rem;
  }
`;
export const RewardsTitleRow = styled.div<{ isLoggedIn?: boolean }>`
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Styles.desktopLarge} {
    padding-block-start: 3rem;
  }
`;

export const RewardsTitle = styled.div<{ isLoggedIn?: boolean }>`
  font-family: 'Flame', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.125rem;
  color: ${primitive.bk.$bbqBrown};

  ${Styles.desktop} {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  ${Styles.desktopLarge} {
    padding-block: 1rem;
  }
`;

export const PageTitleContainer = styled.div`
  display: none; /* hidden by default on mobile */

  ${Styles.desktopLarge} {
    display: flex;
    justify-content: center;
  }
`;

export const PageTitleText = styled.h1`
  font-size: 1.875rem;
  line-height: 2rem;
  font-weight: 400;
  font-family: 'Flame', sans-serif;
  color: ${primitive.bk.$bbqBrown};
  margin: 0;
`;

export const InlineCarouselWrapper = styled.div`
  margin-inline-start: -1.25rem;

  ${Styles.desktop} {
    margin-inline-start: -0.5rem;
  }
`;

export const StyledButton = styled.button`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  letter-spacing: normal;
  text-decoration: underline;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 0;

  ${Styles.desktop} {
    font-size: 0.875rem;
    line-height: 1rem;
  }
`;
